// extracted by mini-css-extract-plugin
export var actionButton = "_ij-t";
export var buttonContainer = "_ij-0";
export var buttonContainer2 = "_ij-1";
export var buttonSection = "_ij-2";
export var details = "_ij-3";
export var dropdownItem = "_ij-5";
export var dropdownItemsContainer = "_ij-4";
export var fileInput = "_ij-r";
export var headerButton = "_ij-6";
export var icon = "_ij-7";
export var input = "_ij-8";
export var macroListItem = "_ij-9";
export var mainContent = "_ij-a";
export var microText = "_ij-b";
export var modal = "_ij-w";
export var optionsButton = "_ij-c";
export var paperclip = "_ij-s";
export var pillContent = "_ij-d";
export var preview = "_ij-e";
export var preview2 = "_ij-f";
export var quillEditor = "_ij-q";
export var selectedMacro = "_ij-g";
export var sidebar = "_ij-h";
export var sidebarHeader = "_ij-j";
export var sidebarList = "_ij-i";
export var sidebarListItem = "_ij-k";
export var sidebarSearch = "_ij-l";
export var snoozeDurationWrapper = "_ij-v";
export var statusPillContainer = "_ij-m";
export var tagsContainer = "_ij-n";
export var unselectedMacro = "_ij-o";
export var variable = "_ij-u";
export var wrapper = "_ij-p";